import _ from "lodash";
import { DEFAULT_RANKING_OPTIONS } from "../constants";
import { IApplication, IClauseInfoData, ISuggestionData } from "../interfaces";
import { ApplicationType, SuggestionAppPage, SuggestionSearchMode } from "../types/enums";
import { FootnoteItem } from "../types/enums/FootnoteItem";

function createBlankApplication(type: ApplicationType): IApplication {
  switch (type) {
    case ApplicationType.HOME_APP: {
      return {
        type,
        name: "Home",
      } as IApplication;
    }
    case ApplicationType.SUGGESTION_APP: {
      return {
        type,
        name: "Search Drafting",
        data: {
          searchText: "",
          searchType: SuggestionSearchMode.SEMANTIC_SEARCH,
          filters: {
            keywords: "",
            title: "",
          },
          metadataTags: [],
          redlined: false,
          highlightUnusualText: false,
          suggestions: [],
          goodSuggestions: [],
          workspaceId: "",
          isFilterOpened: false,
          isRankingOpened: false,
          footnoteItems: [FootnoteItem.RELEVANCY, FootnoteItem.DOCUMENTS],
          rankingOptions: DEFAULT_RANKING_OPTIONS,
          currentPage: SuggestionAppPage.SEARCH_SUGGESTION,
        } as ISuggestionData,
      } as IApplication;
    }
    case ApplicationType.CLAUSE_INFO_APP: {
      return {
        type,
        name: "More Info",
        data: {} as IClauseInfoData,
      } as IApplication;
    }
    default:
      throw new Error(`Error: Invalid or Unsupported application type.`);
  }
}

export function createApplication(type: ApplicationType, initialData?: Record<string, any>): IApplication {
  const application = createBlankApplication(type);
  if (initialData) {
    application.name = initialData.name ?? application.name;
    application.data = _.merge({}, application.data, _.omit(initialData, ["name"]));
  }
  return application;
}
